import { Action } from '@ngrx/store';
import { Quizz, QuizzResponse } from './quizz.models';

export enum QuizzActionTypes {
  LOAD_QUIZZ = '[QuizzAction] Load quizz',
  LOAD_QUIZZ_FAILED = '[QuizzAction] Load quizz failed',
  LOAD_QUIZZ_SUCCESS = '[QuizzAction] Load quizz success',
  SAVE_QUIZZ = '[QuizzAction] Save quizz',
  SAVE_QUIZZ_FAILED = '[QuizzAction] Save quizz failed',
  SAVE_QUIZZ_SUCCESS = '[QuizzAction] Save quizz success',
  QUIZZ_LEFT = '[QuizzAction] Quizz left',
  REDO_QUIZZ = '[QuizzAction] Redo quizz',
  LEAVE_QUIZZ = '[QuizzAction] Leave quizz'
}

export class QuizzActionLoadQuizz implements Action {
  readonly type = QuizzActionTypes.LOAD_QUIZZ;
}

export class QuizzActionLoadQuizzFailed implements Action {
  readonly type = QuizzActionTypes.LOAD_QUIZZ_FAILED;
}

export class QuizzActionLoadQuizzSuccess implements Action {
  readonly type = QuizzActionTypes.LOAD_QUIZZ_SUCCESS;

  constructor(public payload: Quizz) {}
}

export class QuizzActionSaveQuizz implements Action {
  readonly type = QuizzActionTypes.SAVE_QUIZZ;

  constructor(public payload: any) {}
}

export class QuizzActionSaveQuizzFailed implements Action {
  readonly type = QuizzActionTypes.SAVE_QUIZZ_FAILED;
}

export class QuizzActionSaveQuizzSuccess implements Action {
  readonly type = QuizzActionTypes.SAVE_QUIZZ_SUCCESS;

  constructor(public payload: QuizzResponse) {}
}

export class QuizzActionQuizzLeft implements Action {
  readonly type = QuizzActionTypes.QUIZZ_LEFT;
}

export class QuizzActionRedoQuizz implements Action {
  readonly type = QuizzActionTypes.REDO_QUIZZ;
}

export class QuizzActionLeaveQuizz implements Action {
  readonly type = QuizzActionTypes.LEAVE_QUIZZ;
}

export type QuizzActions =
  | QuizzActionLoadQuizz
  | QuizzActionLoadQuizzFailed
  | QuizzActionLoadQuizzSuccess
  | QuizzActionSaveQuizz
  | QuizzActionSaveQuizzFailed
  | QuizzActionSaveQuizzSuccess
  | QuizzActionQuizzLeft
  | QuizzActionRedoQuizz
  | QuizzActionLeaveQuizz;
